import { VStack, VStackTypes } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { SkeletonTagsDesktop } from './desktop';
import { SkeletonTagsMobile } from './mobile';

interface SkeletonItemProps extends VStackTypes.Props {
  itemsCount?: number;
}

export const SkeletonTags: React.FC<SkeletonItemProps> = ({ itemsCount = 1, ...rest }) => {
  const skeleton = useBreakpointValue({
    base: <SkeletonTagsMobile />,
    // sm: <SkeletonTagsTablet />,
    lg: <SkeletonTagsDesktop />,
  });

  const data = Array.from({ length: itemsCount }, (_, i) => i);

  return (
    <VStack space="inline.quarck" pb="inset.nano" {...rest}>
      {data.map((item) => (
        <Box key={item.toString()}>{skeleton}</Box>
      ))}
    </VStack>
  );
};
